import React, { useState } from "react";
import "./style.css";
import {
  CustomLabel,
  accident_typeOFCOVER,
  product_static_list_data,
  regex_obj,
  typeOFCOVER,
} from "../../Constant";
import CustomCard from "../../elements/CustomCard";
import StepperComponent from "../../component/StepperComponent";
import InputComponent from "../../component/InputComponent";
import { Radio, message } from "antd";
import { Lifetime_req_obj } from "../../RequestData";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetDimensions } from "../../Hooks/useGetDemension";
import {
  InitialState,
  onMinusButtonCall,
  onPlusButtonCall,
  setPlanData,
} from "../../Redux/CIReducer";
import TabComponent from "../../component/TabComponent";
import { useIsMobile } from "../../Hooks/useIsMobile";
import { getApi } from "../../service/ApiService";
import { endpoints } from "../../service/endpoints";
import { HTTPRequest } from "../../utility/lib";

const AgePredict = (date, daysdiff = false) => {
  if (date == "") return "00";
  let newArr = date.split("/");
  let newDate1 = [newArr[1], newArr[0], newArr[2]];
  let new_date = newDate1.join("/");
  let newDate = moment().diff(new Date(new_date), "years");
  if (`${newDate}` == "NaN") {
    return "00";
  }
  var current = moment().startOf("day");
  if (daysdiff) {
    var current = moment().startOf("day");
    return moment.duration(current.diff(new_date)).asDays();
  } else {
    return parseInt(newDate);
  }
};

const PersonalAccidentPage = () => {
  const [insuredCheck, setInsuredCheck] = useState("yes");
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const REDIRECTION = process.env.REACT_APP_REDIRECTIO_BASE_URL;
  const CI_coverType = useSelector((state) => state.CI.coverType);
  const agentDataSelected = useSelector((state) => state.agData.agentData);
  const obj = {
    dob: "",
    gender: "",
    relationship: "",
    annualI: "",
    si: "",
  };
  const [userData, setUserData] = useState({
    adult: 2,
    child: 1,
    adultData: [obj, obj],
    childData: [obj],
    pincode: "",
    dropDownopen: false,
    // email: "",
    // phn: "",
    check: true,
    dropDownError: false,
  });
  const typeOfCalculator = useSelector((state) => state.common.type);
  const headerHeight = useGetDimensions("banner", 0).height;
  const [ageError, setAgeError] = useState(false);
  const { adultMember, childMember, coverType } = useSelector(
    (state) => state.CI
  );
  useEffect(() => {}, []);

  const ApiCall = async () => {
    let agevalidationOutput = validateIndividualDate();
    if (
      !ValidateAllInput() ||
      userData.pincode.length !== 6 ||
      !agevalidationOutput
    ) {
      return message.error("Please provide required information");
    }
    // if (!userData.phn) {
    //   return message.error("Please provide mobile number");
    // }
    // if (!userData.email) {
    //   return message.error("Please provide email Id");
    // }
    if (!regex_obj.pincode.test(userData.pincode)) {
      return message.error("Please provide valid pincode");
    }
    // if (!regex_obj.phoneNumberValid.test(userData.phn)) {
    //   return message.error("Please provide valid mobile number");
    // }
    // if (!regex_obj.emailValidation.test(userData.email)) {
    //   return message.error("Please provide valid email Id");
    // }
    dispatch(setPlanData(userData));
    try {
      // const res = await getApi(
      //   // `${endpoints.pincode_for_rest}${userData.pincode}`
      //   `sellonline/v1/location-details/${userData.pincode}/app/all`
      // );
      const pincode_url=`sellonline/v1/location-details/${userData.pincode}/app/all`;
      const res_data = await HTTPRequest.GET("pincode", pincode_url);
      let res = res_data.response;
      if (res) {
        const obj = Lifetime_req_obj({
          userData,
          type: typeOfCalculator,
          zone: res.zonecd,
          agentData: agentDataSelected,
          CI_coverType: CI_coverType.toLowerCase().includes("family")
            ? "familyfloater"
            : CI_coverType,
        });
        const url = `${REDIRECTION}get-product-quote/calculate-lifestyle-protection-accident-care/quick-quote/your-quote?q=${obj}`;
        window.location.href = url;
      }
    } catch (err) {
      console.error(err);
      message.error("something went wrong please try after sometime");
    }
  };
  const validateIndividualDate = () => {
    const age_check = userData.adultData.every(
      (ei) => Number(ei.dob) >= 18 &&  Number(ei.dob) <= 80
    );
    let child_check = true;
    return age_check && child_check;
  };
  const ValidateAllInput = () => {
    if (
      userData.adultData
        .filter((ei) => ei.annualI > 0)
        .some((ei) => !(ei.annualI >= 50000))
    ) {
      return;
    }
    const data_A = userData.adultData.every(
      (ei) => ei.dob !== "" && ei.gender !== "" && ei.relationship !== ""
    );
    const data_C = userData.childData.every(
      (ei) => ei.dob !== "" && ei.gender !== "" && ei.relationship !== ""
    );

    const spouse = userData.adultData.filter(
      (ei) => ei.relationship == "SPOUSE"
    );
    const self = userData.adultData.filter((ei) => ei.relationship == "SELF");
    const otherDependent = [
      ...userData.adultData,
      ...userData.childData,
    ].filter((ei) => ei.relationship != "SPOUSE" && ei.relationship !== "SELF");
    const incomeCheck =
      coverType == typeOFCOVER.ff &&
      self[0]?.si <
        (otherDependent.length > 0
          ? 2000000
          : spouse[0]?.annualI == 0
          ? 1000000
          : true);

    const age_check = userData.adultData.every(
      (ei) =>  Number(ei.dob) >= 18 &&  Number(ei.dob) <= 80
    );
    const childAge_Bro_Sis = userData.childData
      .filter((ei) =>
        ["sister", "brother"].includes(ei.relationship.toLocaleLowerCase())
      )
      .every((ei) =>  Number(ei.dob) >= 5 &&  Number(ei.dob) <= 25);
    const childAge_Son_daughter = userData.childData
      .filter((ei) =>
        ["son", "daughter"].includes(ei.relationship.toLocaleLowerCase())
      )
      .every(
       // (ei) => AgePredict(ei.dob, true) >= 91 && AgePredict(ei.dob) <= 25
       (ei) => Number(ei.dob)  >= 3 && Number(ei.dob) <= 25
      );
    setAgeError(
      !(
        data_A &&
        data_C &&
        childAge_Bro_Sis &&
        age_check &&
        childAge_Son_daughter
      )
    );
    return (
      data_A &&
      data_C &&
      !incomeCheck &&
      childAge_Son_daughter &&
      age_check &&
      childAge_Bro_Sis
    );
  };

  const okButtnClick = () => {
    if (!ValidateAllInput()) {
      return message.error("Please provide required information");
    }
    setUserData({ ...userData, dropDownopen: false });
  };

  const setMinusButton = (e) => {
    if (e === "Adult" && parseInt(userData.adult) === 1) {
      return message.error("Need to select atleast one Adult");
    }
    dispatch(onMinusButtonCall({ type: e }));
  };

  const setPlusButton = (e) => {
    if (parseInt(userData.adult) + parseInt(userData.child) >= 8) {
      return message.error("You had selected maximum member");
    }
    dispatch(onPlusButtonCall({ type: e }));
  };

  useEffect(() => {
    dispatch(InitialState());
    dispatch(onMinusButtonCall({ type: "Adult" }));
    dispatch(onMinusButtonCall({ type: "Child" }));
    setUserData({
      ...userData,
      adult: adultMember.length,
      adultData: adultMember,
      child: childMember.length,
      childData: childMember,
    });
  }, []);

  useEffect(() => {
    setUserData({
      ...userData,
      adult: adultMember.length,
      adultData: adultMember,
      child: childMember.length,
      childData: childMember,
    });
  }, [adultMember, childMember]);

  const handleKeyNumber = (e) => {
    var firstDigit = e.target.value.charAt(0);

    if (
      firstDigit === "0" ||
      firstDigit === "1" ||
      firstDigit === "2" ||
      firstDigit === "3" ||
      firstDigit === "4" ||
      firstDigit === "5"
    ) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      setUserData({ ...userData, phn: e.target.value });
    }
  };

  return (
    <div
      className="bg-color py-4 font-family "
      style={{ marginTop: `${parseInt(headerHeight)}px` }}
    >
      {/* <CustomToast /> */}
      <div className="row gx-2 container">
        <div className="col-xl-8 col-12">
          <div>
            <CustomLabel font_size="28" className="my-4">
              Calculate Your Premium For Personal Accident Health Now
            </CustomLabel>
          </div>
          <div className="col-12">
            <CustomCard>
              <div className="row mb-4">
                <div className="col-lg-6 col-12">
                  <div>
                    <CustomLabel font_size="14">
                      No of. members to secure &nbsp;&nbsp;
                      <CustomLabel font_size="12" color="#c3c2c2">
                        Age 18 & above is Adult
                      </CustomLabel>
                    </CustomLabel>
                  </div>
                  <div className="row">
                    <div className=" col-md-6 col-12">
                      <StepperComponent
                        plusClicked={(e) => setPlusButton("Adult")}
                        minusClicked={(e) => setMinusButton("Adult")}
                        label={"Adults"}
                        value={userData.adult}
                      />
                    </div>
                    <div className=" col-md-6 col-12">
                      <StepperComponent
                        plusClicked={(e) => setPlusButton("Child")}
                        minusClicked={(e) => setMinusButton("Child")}
                        label={"Kids"}
                        value={userData.child}
                      />
                    </div>
                    {userData.adult + userData.child > 1 && (
                      <div className=" col-12">
                        <TabComponent />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <InputComponent
                        label={"Enter Age & Gender"}
                        placeholder="Enter AGE & Gender"
                        value={
                          userData.adultData.length > 0
                            ? userData.adultData[0].dob
                            : userData.childData[0].dob
                        }
                        onChange={(e) => {
                          setUserData({ ...userData, dropDownopen: true });
                        }}
                        onCancel={(e) => {
                          setUserData({ ...userData, dropDownopen: false });
                        }}
                        onOk={() => {
                          okButtnClick();
                        }}
                        onDataChange={() => {}}
                        data={userData}
                        dropdownComponent={true}
                        dropDownopen={userData.dropDownopen}
                        readOnly={true}
                        ageError={ageError}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <InputComponent
                        label={"Pincode"}
                        regex={regex_obj.pincode}
                        placeholder="Enter Pincode"
                        value={userData.pincode}
                        onChange={(e) => {
                          setUserData({ ...userData, pincode: e.target.value });
                        }}
                        maxLength={6}
                      />
                    </div>
                    <div className="my-3">
                      <CustomLabel
                        font_size="12"
                        font_weight="bold"
                        color="#c3c2c2"
                      >
                        Same as mentioned in Aadhaar card / Passport / Driving
                        License or any other document
                      </CustomLabel>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-10 col-12 d-inline-block">
                  <CustomLabel font_size="15" className="mx-2">
                    Is proposer is same as Insured?
                  </CustomLabel>
                  <Radio.Group
                    onChange={(e) => setInsuredCheck(e.target.value)}
                    value={insuredCheck}
                  >
                    <Radio value={"yes"}>Yes</Radio>
                    <Radio value={"no"}>No</Radio>
                  </Radio.Group>
                </div> */}
                {/* <div
                  className={
                    isMobile ? "col-md-6 col-12 mb-4" : "col-md-6 col-12"
                  }
                >
                  <InputComponent
                    label={"Email"}
                    regex={regex_obj.emailValidation}
                    placeholder="Enter Your Email ID"
                    value={userData.email}
                    onChange={(e) => {
                      setUserData({ ...userData, email: e.target.value });
                    }}
                  />
                </div> */}
                {/* <div className="col-md-6 col-12">
                  <InputComponent
                    label={"Contact Number"}
                    regex={regex_obj.phoneNumberValid}
                    placeholder="Enter Your Phone Number"
                    value={userData.phn}
                    onChange={(e) => {
                      handleKeyNumber(e);
                    }}
                    extraData={true}
                    maxLength={10}
                  />
                </div> */}
              </div>
              {/* <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  onChange={() =>
                    setUserData({ ...userData, check: !userData.check })
                  }
                />
                <CustomLabel font_size="10" font_weight="normal">
                  By submitting my details, I override my NDNC registration and
                  authorize ManipalCigna Health Insurance and its
                  representatives to contact me through call, RCS, Whatsapp or
                  E-mail. I further consent to share my information on
                  confidential basis with third parties for evaluating and
                  processing this proposal.
                </CustomLabel>
              </div> */}
            </CustomCard>
            <div className="col-12 card_footer" onClick={ApiCall}>
              <CustomLabel color="white">
                {"Get Quotes".toLocaleUpperCase()}
              </CustomLabel>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-12">
          <div>
            <CustomLabel font_size="30" className="my-2">
              &nbsp;
            </CustomLabel>
          </div>
          <div className="row justify-content-center">
            {/* <div className="col-10">
              <img src="https://www.manipalcigna.com/o/com.mchi.lifetime.health/images/MCHI_Prime.png " />
            </div> */}
            {/* <div className="col-10 mb-2">
              <div className="row mt-4">
                {product_static_list_data.map((ei) => {
                  return (
                    <React.Fragment key={`${ei}`}>
                      <div className="col-2">
                        <span className="round-img"></span>
                      </div>
                      <div className="col-10 my-2">
                        <CustomLabel font_size="12" font_weight="normal">
                          {ei}
                        </CustomLabel>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalAccidentPage;
